import script from "./MTagList.vue?vue&type=script&setup=true&lang=js"
export * from "./MTagList.vue?vue&type=script&setup=true&lang=js"

import "./MTagList.vue?vue&type=style&index=0&id=367382c4&lang=scss"

const __exports__ = script;

export default __exports__